import { atom } from "jotai";

export const chatStatusAtom = atom("idle");

export const chatSuppressionsAtom = atom(new Set());

export const withSuppression = (id) => (suppressions) =>
  new Set(suppressions).add(id);

export const withoutSuppression = (id) => (suppressions) =>
  new Set([...suppressions].filter((suppressor) => suppressor !== id));
